import { createRouter, createWebHistory } from "vue-router";
import { createApp } from "vue";

import Login from "./components/login.vue";
import Dashboard from "./components/Dashboard.vue";
import Users from "./components/Users.vue";
import AddUser from "./components/AddUser.vue";
import AppItems from "./components/AppItems.vue";
import AddAppItem from "./components/AddAppItem.vue";
import EditUserPage from "./components/EditUserPage.vue";
import EditAppItem from "./components/EditAppItem.vue";
import Categories from "./components/Categories.vue";
import EditCategory from "./components/EditCategories.vue";
import AddCategory from "./components/AddCategory.vue";
import ActivityLog from "./components/ActivityLog.vue";
import AuditLogs from "./components/AuditLogs.vue";
import requirePrivilegeToRoute from "./routeGuards.js";
import ComingSoon from "./components/ComingSoon.vue";
import Teams from "./components/Teams.vue";
import Departments from "./components/Departments.vue";
import AddDepartment from "./components/AddDepartment.vue";
import EditDepartment from "./components/EditDepartment.vue";

//-----------------  Netpay Router ------------------------------------//

import NetpayIndex from "./modules/Netpay-Settlement/Netpay-index.vue";
import SettlementReprocess from "./modules/Netpay-Settlement/SettlementReprocess.vue";
import BulkSettlementReprocess from "./modules/Netpay-Settlement/BulkSettlementReprocess.vue";
import ViewReprocessedTransactions from "./modules/Netpay-Settlement/ViewReprocessedTransactions.vue";

//--------------------------------------------------------------------//

//--------------E-Signature----------------------------//

import eSignature from "./modules/E-Signature/E-signature.vue";
import SendRequest from "./modules/E-Signature/SendRequest.vue";
// import TestDND from './modules/E-Signature/Container.vue';

//-----------------  InApp Notification Router ------------------------------------//

import PushNotification from "./modules/InApp-Notification/PushNotification.vue";

//--------------------------------------------------------------------//

//-----------------  Sale Executive Board ------------------------------------//

import SEDashboard from "./modules/Sale-Executive-Portal/Dashboard.vue";
import SEBusinesses from "./modules/Sale-Executive-Portal/Businesses.vue";
import SEBusinessesDetails from "./modules/Sale-Executive-Portal/BusinessDetails.vue";

//--------------------------------------------------------------------//

//-----------------  Administrative Portal ------------------------------------//

import APDashboard from "./modules/Administrative-Portal/Dashboard.vue";
import APSalesExecutives from "./modules/Administrative-Portal/Sales-Execs.vue";
import APSalesExecDetails from "./modules/Administrative-Portal/Sales-Execs-Details.vue";
import APSalesExecMerchants from "./modules/Administrative-Portal/Sales-Execs-Merchants.vue";
import APBankMerchants from "./modules/Administrative-Portal/BankMerchants.vue";

//--------------------------------------------------------------------//

//-----------------  IsoLogs Module ------------------------------------//

import IsoLogs from "./modules/IsoLogs/IsoLogs.vue";

const app = createApp({});
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/login" },
    { path: "/login", component: Login },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/mobile",
      name: "mobile",
      component: Dashboard,
      meta: { salesExecutiveRestricted: true },
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/adduser",
      name: "addusers",
      component: AddUser,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/categories",
      name: "categories",
      component: Categories,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/appitems",
      name: "appitems",
      component: AppItems,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/addappitems",
      name: "addappitems",
      component: AddAppItem,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/addcategory",
      name: "addcategories",
      component: AddCategory,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/activities",
      name: "activities",
      component: ActivityLog,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/auditlogs",
      name: "auditlogs",
      component: AuditLogs,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/comingsoon",
      name: "comingsoon",
      component: ComingSoon,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/teams",
      name: "teams",
      component: Teams,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/departments",
      name: "departments",
      component: Departments,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/departments/add-dept",
      name: "adddepartments",
      component: AddDepartment,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
    },
    {
      path: "/departments/edit-dept",
      name: "editdepartments",
      component: EditDepartment,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
      props: (route) => ({ DID: route.query.DID }),
    },
    {
      path: "/edituser",
      name: "editusers",
      component: EditUserPage,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
      props: (route) => ({ email: route.query.email }),
    },
    {
      path: "/editappitem",
      name: "editappitem",
      component: EditAppItem,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
      props: (route) => ({ app: route.query.app }),
    },
    {
      path: "/editcategory",
      name: "editcategories",
      component: EditCategory,
      meta: { requiresAuth: true, salesExecutiveRestricted: true },
      props: (route) => ({ CID: route.query.CID }),
    },

    //------------ Netpay Router ----------------//
    {
      path: "/netpay",
      component: NetpayIndex,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/netpay",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/settlement",
      component: SettlementReprocess,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/netpay",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/bulksettlement",
      component: BulkSettlementReprocess,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/netpay",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/view-transactions",
      component: ViewReprocessedTransactions,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/netpay",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
    { path: "/:catchAll(.*)", redirect: "/dashboard" },

    //---------------- E-Signature ----------------------//
    {
      path: "/e-signature",
      component: eSignature,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/e-signature",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/e-signature/sendRequest",
      component: SendRequest,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/e-signature",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },

    //------------ Notification Router ----------------//

    {
      path: "/notification",
      component: PushNotification,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/notification",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },

    //------------ Sale Executive Router ----------------//

    {
      path: "/sales/dashboard",
      name: "sales-dashboard",
      component: SEDashboard,
      meta: { requiresAuth: true, salesExecutiveOnly: true },
    },
    {
      path: "/sales/business",
      name: "sales-business",
      component: SEBusinesses,
      meta: { requiresAuth: true, salesExecutiveOnly: true },
    },
    {
      path: "/sales/business/details",
      name: "sales-business-details",
      component: SEBusinessesDetails,
      meta: { requiresAuth: true, salesExecutiveOnly: true },
      props: (route) => ({ MID: route.query.MID }),
    },

    //------------ Administrative Dashboard Router ----------------//

    {
      path: "/administrative",
      name: "Admin-dashboard",
      component: APDashboard,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/administrative",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/administrative/sales-execs",
      name: "sales-execs",
      component: APSalesExecutives,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/administrative",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/administrative/sales-execs/details",
      name: "sales-execs-details",
      component: APSalesExecDetails,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/administrative",
        salesExecutiveRestricted: true,
      },
      props: (route) => ({ SEID: route.query.SEID }),
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/administrative/sales-execs/merchants",
      name: "sales-execs-merchants",
      component: APSalesExecMerchants,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/administrative",
        salesExecutiveRestricted: true,
      },
      props: (route) => ({ MID: route.query.MID, SEID: route.query.SEID }),
      beforeEnter: requirePrivilegeToRoute,
    },
    {
      path: "/administrative/bank-merchants",
      name: "bank-merchants",
      component: APBankMerchants,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/administrative",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },

    //------------ IsoLogs Router ----------------//

    {
      path: "/logs",
      component: IsoLogs,
      meta: {
        requiresAuth: true,
        requiresPrivilege: "/logs",
        salesExecutiveRestricted: true,
      },
      beforeEnter: requirePrivilegeToRoute,
    },
  ],
  app: {
    config: app.config,
  },
});

const restrictedRoutesForSupport = [
  "/adduser",
  "/addappitems",
  "/addcategory",
  "/editcategory",
  "/editappitem",
  "/categories",
  "/appitems",
  "/auditlogs",
  "/departments",
  "/departments/add-dept",
  "/departments/edit-dept",
];

router.beforeEach((to, from, next) => {
  const isAuthenticated = () => {
    const token = sessionStorage.getItem("token");
    return !!token;
  };

  const getUserRole = () => {
    return sessionStorage.getItem("role");
  };
  const getIsTeamLead = () => {
    return sessionStorage.getItem("isTeamLead");
  };

  if (to.meta.requiresAuth && !isAuthenticated()) {
    console.log("User not permitted");
    next("/login");
  } else if (
    to.name === "mobile" &&
    to.query.token &&
    to.query.firstName &&
    to.query.lastName &&
    to.query.email &&
    to.query.userId &&
    to.query.role &&
    to.query.department
  ) {
    sessionStorage.setItem("token", to.query.token);
    sessionStorage.setItem("firstName", to.query.firstName);
    sessionStorage.setItem("lastName", to.query.lastName);
    sessionStorage.setItem("email", to.query.email);
    sessionStorage.setItem("userId", to.query.userId);
    sessionStorage.setItem("role", to.query.role);
    sessionStorage.setItem("department", to.query.department);
    sessionStorage.setItem("platform", "mobile");

    console.log("calling mobile route");

    next("/dashboard");
  } else if (!to.meta.requiresAuth && isAuthenticated()) {
    next("/dashboard");
  } else if (
    restrictedRoutesForSupport.includes(to.path) &&
    getUserRole() === "Support" &&
    getIsTeamLead() == "false"
  ) {
    console.log("Teamlead value is: " + getIsTeamLead());
    next("/dashboard");
  } else if (
    to.meta.salesExecutiveOnly &&
    getUserRole() !== "Sales Executive"
  ) {
    console.log("Unauthorized access for Sales Executive only route");
    next("/dashboard");
  } else if (
    to.meta.salesExecutiveRestricted &&
    getUserRole() === "Sales Executive"
  ) {
    console.log("Unauthorized access for Sales Executive only route");
    next("/sales/dashboard");
  } else {
    next();
  }
});

window.addEventListener("popstate", () => {
  const currentRoute = router.currentRoute.value;

  if (
    currentRoute.path == "/dashboard" &&
    currentRoute.matched.some((record) => record.meta.requiresAuth)
  ) {
    const confirmation = window.confirm(
      "Your session has expired. You will be logged out."
    );
    if (confirmation) {
      sessionStorage.removeItem("token");
      router.push("/login");
    }
  }
});

export default router;
